import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";

/**
 * Header search. The hero has its own richer search with suggestions, but that
 * only exists on the homepage — a shopper deep in a category needs the box in
 * the chrome, on every page.
 */
const HeaderSearch = ({ className = "" }) => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [term, setTerm] = useState(params.get("q") || "");

  const submit = (e) => {
    e.preventDefault();
    const value = term.trim();
    if (!value) return;
    navigate(`/search?q=${encodeURIComponent(value)}`);
  };

  return (
    <form
      onSubmit={submit}
      role="search"
      className={`flex items-stretch overflow-hidden rounded-lg bg-white ${className}`}
    >
      <input
        type="search"
        value={term}
        onChange={(e) => setTerm(e.target.value)}
        placeholder="Search servers, storage, networking…"
        aria-label="Search products"
        className="min-w-0 flex-1 px-3 py-2 text-sm text-gray-900 placeholder-gray-400
                   focus:outline-none"
      />
      <button
        type="submit"
        aria-label="Search"
        className="flex shrink-0 items-center justify-center bg-[var(--website-secondary-color)]
                   px-3 text-[var(--website-primary-color)] transition-[filter] hover:brightness-105"
      >
        <Search size={17} strokeWidth={2.5} />
      </button>
    </form>
  );
};

export default HeaderSearch;
